import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiArrowLeft, FiShare2, FiHeart } from "react-icons/fi";
import Notiflix from "notiflix";
import { getUUID, postAffirmationsLike } from "../../../services/api";
import { getToken } from "../../../services/cookies";
import { useNavigate, useParams } from "react-router-dom";

export default function AffirmationMessage({ data }) {
  const navigate = useNavigate();
  const { id, moduleId } = useParams();
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [likeLoading, setLikeLoading] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [currentAffirmation, setCurrentAffirmation] = useState({
    message: data.affirmation.affirmations[0].text,
    backgroundImage: "/assets/affirmations/bg.jpg",
  });

  const affirmationCategories = [
    {
      name: "Kendine Güven ve Güç Kazan",
      color: "text-white",
      backgroundImage: "/assets/affirmations/confidence.png",
    },
    {
      name: "Zihin-Beden Dengesi ve Sağlık",
      color: "text-white",
      backgroundImage: "/assets/affirmations/health.png",
    },
    {
      name: "Sevgi Dolu İlişkiler Yarat",
      color: "text-white",
      backgroundImage: "/assets/affirmations/love.png",
    },
    {
      name: "Bolluk ve Para Akışı",
      color: "text-white",
      backgroundImage: "/assets/affirmations/money.png",
    },
    {
      name: "Başarıya Giden Yol",
      color: "text-white",
      backgroundImage: "/assets/affirmations/motivation.png",
    },
    {
      name: "Ruhsal Uyanış ve Huzur",
      color: "text-white",
      backgroundImage: "/assets/affirmations/wakingUp.png",
    },
    {
      name: "Şükran ve İçsel Mutluluk",
      color: "text-white",
      backgroundImage: "/assets/affirmations/happy.png",
    },
  ];

  const getShareText = () => {
    const clean = (currentAffirmation?.message || "").replace(/\n/g, " ");
    return `Jodiac bana bu olumlama mesajını gönderdi!
  ${clean}
  Sen de katıl : https://jodi.ac`;
  };

  const handleShare = async () => {
    const text = getShareText();
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ text });
        return;
      } catch (e) {
        // kullanıcı iptal edebilir
      }
    }
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        window.alert("Metin panoya kopyalandı.");
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        window.alert("Metin panoya kopyalandı.");
      }
    } catch (e) { }
  };

  const handleLike = async () => {
    if (likeLoading) return;
    try {
      setLikeLoading(true);
      await postAffirmationsLike({ affirmation_id: data?.affirmation?.affirmations[0].id });
      setIsLiked((prev) => !prev);
      Notiflix.Notify.success("Beğeniniz kaydedildi.");
    } catch (e) {
      Notiflix.Notify.failure("Beğeni gönderilemedi.");
    } finally {
      setLikeLoading(false);
    }
  };

  const handleCategorySelect = (category) => {
    // Here you would typically navigate to the specific category or show affirmations
  };




  const fetchData = async () => {
    const token = getToken("jodiactoken");
    if (token) {
      const response = await getUUID();
      if (response.uuid === data.user.id) {
        setIsOwner(true);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [data.user.id]);

  const [isRevealed, setIsRevealed] = useState(false);

  // Initialize checks
  useEffect(() => {
    const checkOwner = async () => {
      const token = getToken("jodiactoken");
      if (token) {
        const response = await getUUID();
        if (response.uuid === data.user.id) {
          setIsOwner(true);
        }
      }
    };
    checkOwner();
  }, [data.user.id]);

  const handleReveal = () => {
    setIsRevealed(true);
  };

  return (
    <div className="w-full h-[500px] min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed]">
      <motion.div
        className="affirmation-container flex flex-col items-center w-full h-full bg-slate-900 shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-hidden select-none"
        style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}
      >
        {/* Background Image with animated parallax effect potentially */}
        <motion.div
          className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${currentAffirmation.backgroundImage})`,
          }}
          animate={isRevealed ? { scale: 1.05 } : { scale: 1 }}
          transition={{ duration: 10, repeat: Infinity, repeatType: "reverse" }}
        />

        {/* Darker Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />

        {/* Header with Back Button and User Info */}
        <div className="relative z-10 w-full">
          <div className="flex text-white mt-8 w-full items-center justify-between px-6">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate(`/${id}/`)}
                className="p-2 -ml-2 hover:bg-white/10 rounded-full transition-colors backdrop-blur-sm"
              >
                <FiArrowLeft className="w-6 h-6" />
              </button>
              <div>
                <h2 className="text-base font-medium leading-tight">{data?.user?.first_name} {data?.user?.last_name}</h2>
                <p className="text-xs text-white/60 font-light tracking-wide">Günlük Olumlama</p>
              </div>
            </div>
            {/* Optional: Add a small icon or branding here */}
          </div>
        </div>


        {/* Main Content Area */}
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-8 w-full">
          <AnimatePresence mode="wait">
            {!isRevealed ? (
              <motion.div
                key="orb-interaction"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 1.5, filter: "blur(20px)" }}
                transition={{ duration: 0.8 }}
                className="flex flex-col items-center justify-center cursor-pointer group"
                onClick={handleReveal}
              >
                {/* Glowing Orb */}
                <div className="relative w-48 h-48 flex items-center justify-center">
                  {/* Outer Rings - Animated */}
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                    className="absolute inset-0 rounded-full border border-white/20 border-dashed"
                  />
                  <motion.div
                    animate={{ rotate: -360 }}
                    transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
                    className="absolute inset-4 rounded-full border border-white/10"
                  />

                  {/* Core Glow */}
                  <motion.div
                    animate={{ scale: [1, 1.1, 1], opacity: [0.5, 0.8, 0.5] }}
                    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute inset-0 rounded-full bg-gradient-to-br from-[#3DA7B5]/40 to-purple-500/40 blur-xl"
                  />

                  {/* The Orb Itself */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="relative w-32 h-32 rounded-full bg-gradient-to-br from-[#3DA7B5]/20 to-white/10 backdrop-blur-md border border-white/30 shadow-[0_0_30px_rgba(61,167,181,0.3)] flex items-center justify-center overflow-hidden"
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-[#3DA7B5]/20 to-transparent" />
                    <div className="text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.8)]">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" />
                      </svg>
                    </div>
                  </motion.div>
                </div>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="mt-10 text-white/90 text-2xl font-semibold tracking-widest uppercase text-center"
                >
                  ENERJİNİ HİSSET
                  <span className="block mt-1">DOKUN</span>
                </motion.p>
              </motion.div>
            ) : (
              <motion.div
                key="message-reveal"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }} // nice cubic bezier
                className="flex flex-col items-center text-center w-full"
              >
                {/* Decorative Elements */}
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 0.5, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="mb-6"
                >
                  <img src="/assets/pngImages/favorite.png" alt="Star" className="w-8 h-8 opacity-50 grayscale invert brightness-200" />
                </motion.div>

                <div className="relative p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl w-full">
                  <motion.h2
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="text-white text-2xl sm:text-3xl font-medium leading-relaxed whitespace-pre-line drop-shadow-lg"
                    style={{ fontFamily: 'Aclonica, cursive' }}
                  >
                    "{currentAffirmation.message}"
                  </motion.h2>
                </div>

                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 1 }}
                  className="flex items-center gap-6 mt-10"
                >
                  <button
                    onClick={handleShare}
                    className="flex flex-col items-center gap-2 group"
                  >
                    <div className="p-4 rounded-full bg-white/10 backdrop-blur-md border border-white/20 group-hover:bg-[#3DA7B5] transition-all duration-300 shadow-lg">
                      <FiShare2 className="w-6 h-6 text-white" />
                    </div>
                    <span className="text-xs text-white/60">Paylaş</span>
                  </button>

                  <button
                    onClick={handleLike}
                    disabled={likeLoading}
                    className="flex flex-col items-center gap-2 group"
                  >
                    <div className={`p-4 rounded-full backdrop-blur-md border border-white/20 transition-all duration-300 shadow-lg ${isLiked ? 'bg-red-500/20 border-red-500/50' : 'bg-white/10 group-hover:bg-red-500/20'}`}>
                      {isLiked ? (
                        <FiHeart className="w-6 h-6 text-red-500 fill-current" />
                      ) : (
                        <FiHeart className="w-6 h-6 text-white group-hover:text-red-400" />
                      )}
                    </div>
                    <span className="text-xs text-white/60">Beğen</span>
                  </button>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Bottom Section - Categories */}
        <div className="fixed bottom-0 left-0 right-0 z-20 w-full ">
          <motion.div
            className="relative w-full"
            drag="y"
            dragConstraints={{ top: -50, bottom: 0 }}
            dragElastic={0.1}
            dragSnapToOrigin={true}
            onDrag={(event, info) => {
              if (info.offset.y < -30) setIsBottomSheetOpen(true);
            }}
            whileHover={{ y: -5 }}
            animate={{ y: 0 }}
          >
            {/* Glowing Hint */}
            <div className="absolute -top-12 left-0 right-0 flex justify-center pb-4 opacity-50">
              <div className="animate-bounce text-white/50 text-xs tracking-widest uppercase">
                Diğer Kategoriler
              </div>
            </div>

            <motion.button
              onClick={() => setIsBottomSheetOpen(true)}
              className="w-full relative h-[60px] rounded-t-[30px] overflow-hidden"
            >
              <div className="absolute inset-0 bg-white/90 backdrop-blur-xl" />
              <div className="absolute top-0 inset-x-0 h-[1px] bg-white/50" />

              <div className="relative flex flex-col items-center justify-center h-full pt-1">
                <div className="w-12 h-1.5 bg-gray-300 rounded-full mb-1" />
                <span className="text-gray-500 text-xs font-medium uppercase tracking-wider">Yukarı Kaydır</span>
              </div>
            </motion.button>
          </motion.div>
        </div>

        {/* Bottom Sheet Overlay */}
        <AnimatePresence>
          {isBottomSheetOpen && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setIsBottomSheetOpen(false)}
                className="absolute inset-0 bg-black/60 backdrop-blur-[2px] z-30"
              />
              <motion.div
                initial={{ y: "100%" }}
                animate={{ y: 0 }}
                exit={{ y: "100%" }}
                transition={{ type: "spring", damping: 30, stiffness: 300 }}
                className="absolute bottom-0 left-0 right-0 z-40 bg-[#e8e9ed] rounded-t-[32px] h-[85%] overflow-hidden flex flex-col shadow-2xl"
                drag="y"
                dragConstraints={{ top: 0, bottom: 0 }}
                dragElastic={0.05}
                onDragEnd={(e, { offset, velocity }) => {
                  if (offset.y > 100 || velocity.y > 500) {
                    setIsBottomSheetOpen(false);
                  }
                }}
              >
                <div className="w-full flex justify-center pt-4 pb-2 bg-white">
                  <div className="w-16 h-1.5 bg-gray-300 rounded-full" />
                </div>

                <div className="bg-white px-6 pb-6 rounded-b-[32px] mb-2 z-10 shadow-sm relative">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-gray-800 font-bold text-xl">Kategoriler</h3>
                    <button onClick={() => setIsBottomSheetOpen(false)} className="p-2 bg-gray-100 rounded-full hover:bg-gray-200">
                      <svg className="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed">
                    Ruh halinize ve ihtiyacınıza en uygun olumlama kategorisini seçerek enerjinizi yükseltin.
                  </p>
                </div>

                <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3 pb-24">
                  {affirmationCategories.map((category, index) => (
                    <motion.button
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.05 }}
                      onClick={() => handleCategorySelect(category)}
                      className="w-full group relative h-20 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
                    >
                      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{ backgroundImage: `url(${category.backgroundImage})` }} />
                      <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors duration-300" />
                      <div className="relative z-10 flex items-center justify-between px-6 h-full">
                        <span className="text-white font-bold text-lg tracking-wide">{category.name}</span>
                        <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-white group-hover:text-[#3DA7B5] transition-all text-white">
                          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </div>
                    </motion.button>
                  ))}
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}
